/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */
import _parseInt from "@babel/runtime-corejs3/core-js-stable/parse-int";
import _bindInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/bind";
import _newArrowCheck from "@babel/runtime-corejs3/helpers/esm/newArrowCheck";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";

/** @module core/modules/number-utils/parse-int-all */

/**
 * @description Parses all successive integers and returns an array with the results.
 * @param {(string|number)} input - Input.
 * @returns {(Array<number>|null)} Parsed integers array or null.
 */
function parseIntAll(input) {
  var _this = this;

  if (typeof input === 'string' && input.length > 0) {
    var _context, _context2;

    return _mapInstanceProperty(_context = input.match(/\d+/g) || []).call(_context, _bindInstanceProperty(_context2 = function _context2(val) {
      _newArrowCheck(this, _this);

      return _parseInt(val);
    }).call(_context2, this));
  } else if (typeof input === 'number') {
    return [input];
  } else {
    return null;
  }
}

export { parseIntAll };